import { toArray } from '../utils/commonUtil';
import { injectPropsWithOption } from '../utils/valueUtil';
import { computed } from 'vue';
function includes(test, search) {
    return toArray(test).join('').toUpperCase().includes(search);
}
export default (options, fieldNames, searchValue, filterOption, optionFilterProp) => computed(() => {
    if (!searchValue.value || filterOption.value === false) {
        return options.value;
    }
    const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames.value;
    const filteredOptions = [];
    const customizeFilter = typeof filterOption.value === 'function';
    const upperSearch = searchValue.value.toUpperCase();
    const filterFunc = customizeFilter
        ? filterOption.value
        : (_, option) => {
            // Use provided `optionFilterProp`
            if (optionFilterProp.value) {
                return includes(option[optionFilterProp.value], upperSearch);
            }
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) {
                // hack `fieldLabel` since `OptionGroup` children is not `label`
                return includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            }
            return includes(option[fieldValue], upperSearch);
        };
    const wrapOption = customizeFilter
        ? opt => injectPropsWithOption(opt)
        : opt => opt;
    options.value.forEach(item => {
        // Group should check child options
        if (item[fieldOptions]) {
            // Check group first
            const matchGroup = filterFunc(searchValue.value, wrapOption(item));
            if (matchGroup) {
                filteredOptions.push(item);
            }
            else {
                // Check option
                const subOptions = item[fieldOptions].filter((subItem) => filterFunc(searchValue.value, wrapOption(subItem)));
                if (subOptions.length) {
                    filteredOptions.push(Object.assign(Object.assign({}, item), { [fieldOptions]: subOptions }));
                }
            }
            return;
        }
        if (filterFunc(searchValue.value, wrapOption(item))) {
            filteredOptions.push(item);
        }
    });
    return filteredOptions;
});
